import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './core/services/settings.service';
import {UiService} from './core/services/ui.service';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit{
  title = 'LumiiWebCompatibility';

  constructor(
    private translate: TranslateService,
    private settingsService: SettingsService,
    private router: Router,
    public uiService: UiService
  ) {
    this.translate.setDefaultLang(this.settingsService.getLang());
  }

  ngOnInit() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.uiService.stopGlobalLoading();
      }
    });
  }
}
